var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPage11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 36,
    viewBox: "0 0 135 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_10610_2893)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 17.7456L5.82218 16.7383V19.2567C5.82218 21.6979 7.37611 22.8228 9.15876 22.8228C11.1768 22.8228 12.381 21.3487 12.381 19.297V0.580078H18.5126V19.4515C18.5126 24.4514 14.6715 28.6353 9.19575 28.6353C3.72001 28.6353 0 25.0323 0 19.569V17.749V17.7456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M41.997 18.408C41.997 24.375 37.5337 28.6395 31.7485 28.6395C25.9633 28.6395 21.5 24.3783 21.5 18.408C21.5 12.4377 26.0037 8.2168 31.7485 8.2168C37.4933 8.2168 41.997 12.441 41.997 18.408ZM36.0975 18.408C36.0975 15.1542 34.0021 13.6432 31.7485 13.6432C29.495 13.6432 27.4029 15.1542 27.4029 18.408C27.4029 21.6618 29.5387 23.2132 31.7485 23.2132C33.9583 23.2132 36.0975 21.6618 36.0975 18.408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M45.4142 35.4552L49.8002 25.4588L41.6875 8.79688H48.2866L52.9821 19.1056L57.2503 8.79688H63.4997L51.6232 35.4586H45.4142V35.4552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M64.5112 14.3752C64.5112 5.81252 71.033 0 78.7185 0C86.9859 0 90.6353 5.30883 91.5266 9.26108L85.7415 11.0811C85.3143 9.18385 83.5687 5.96698 78.7152 5.96698C75.0288 5.96698 70.8749 8.60293 70.8749 14.3752C70.8749 19.5295 74.679 22.5113 78.7925 22.5113C83.5687 22.5113 85.469 19.3348 86.0105 17.357L91.8731 19.0225C90.9818 22.8203 87.3324 28.6328 78.7925 28.6328C70.8749 28.6328 64.5078 22.9378 64.5078 14.3718L64.5112 14.3752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M113.38 18.408C113.38 24.375 108.917 28.6395 103.131 28.6395C97.3462 28.6395 92.8828 24.3783 92.8828 18.408C92.8828 12.4377 97.3865 8.2168 103.131 8.2168C108.876 8.2168 113.38 12.441 113.38 18.408ZM107.48 18.408C107.48 15.1542 105.385 13.6432 103.135 13.6432C100.885 13.6432 98.7857 15.1542 98.7857 18.408C98.7857 21.6618 100.922 23.2132 103.135 23.2132C105.348 23.2132 107.48 21.6618 107.48 18.408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M120.246 27.6698C120.633 29.5301 122.187 30.8867 124.4 30.8867C127.35 30.8867 129.173 29.4529 129.173 25.964V25.0742C128.473 26.1218 126.805 27.2434 124.01 27.2434C118.887 27.2434 115.043 23.2139 115.043 17.8648C115.043 12.5156 118.729 8.44922 124.01 8.44922C127.155 8.44922 128.823 9.84275 129.368 10.8501V8.79508H134.995V25.6517C134.995 31.1922 131.891 35.9974 124.669 35.9974C119.12 35.9974 115.588 32.5858 115.043 29.1372L120.243 27.6631L120.246 27.6698ZM129.213 17.8648C129.213 15.2288 127.313 13.6036 125.1 13.6036C122.887 13.6036 120.946 15.2322 120.946 17.8648C120.946 20.4973 122.732 22.1259 125.1 22.1259C127.468 22.1259 129.213 20.4973 129.213 17.8648Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10610_2893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage11);
export default __webpack_public_path__ + "static/media/page1_1.1a02a97b87f826447442c50a5b2280bb.svg";
export { ForwardRef as ReactComponent };